import styles from "../Settings/AppVersion.module.css";
import AddTicketsUsersAndLeagues from "./AddTicketsUsersAndLeagues";
import { useState } from "react";
import AddTicketsTeams from "./AddTicketsTeams";
import PickEvents from "./PickEvents";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddTicketDetailsForm from "./AddTicketDetailsForm";

interface TicketDetailsInput {
    userId: string;
    leagueId: string;
    homeTeamId: string;
    awayTeamId: string;
    isBulkList: boolean;
    eventId: string;
    userEmail: string;
    leagueName: string;
    homeTeamName: string;
    awayTeamName: string;
    eventName?: string;
    venueName?: string;
    leagueType?: string|null;
}

export interface AddTicketsInput {
    setPage: (page: number) => void;
    ticketDetails: TicketDetailsInput | null;
    setTicketDetails: (ticketDetails: any) => void;
    register?: any;
    setValue?: any;
    setSearch?: (is_search: any) => void;
    watchedFields?: any;
    search?: boolean;
    errors?: any
    handleSubmit?: any;
    trigger?: any;
    page?: number;
    isFrom?: string;
    resetEvent?: boolean
    setResetEvent?: (is_reset: boolean) => void;
}


const AddTickets = () => {
    const [page, setPage] = useState(0);
    const [ticketDetails, setTicketDetails] = useState<TicketDetailsInput | null>(null);

    const renderTickets = () => {
        switch(page) {
            case 0:
                return <AddTicketsUsersAndLeagues setPage = {setPage} setTicketDetails = {setTicketDetails} ticketDetails = {ticketDetails} page = {page} />
            case 1: 
                return <AddTicketsTeams setPage = {setPage} setTicketDetails = {setTicketDetails} ticketDetails = {ticketDetails} page = {page} />
            case 2:
                return <PickEvents setPage = {setPage} setTicketDetails = {setTicketDetails} ticketDetails = {ticketDetails} page = {page} isFrom={'addTickets'}/>
            case 3:
                return <AddTicketDetailsForm setPage = {setPage} setTicketDetails = {setTicketDetails} ticketDetails = {ticketDetails} page = {page} />
        }
    }

    const handleBackPress = () => {
        setPage(page-1);
    }

    return (
         <div className={styles.maindiv}>
            
                <div className={styles.seconddiv} style = {page === 2 ? {width: '90%', gap: '0px'} : page === 3 ? {width: '50%', gap: '5px'} : {}}>
                {
                    page !== 0 && <div style = {{width: '100%', cursor: 'pointer'}} onClick = {handleBackPress}>
                    <ArrowBackIcon />
                    </div>
                }
                    {renderTickets()}
                </div>
            </div>
        
    )
}

export default AddTickets;
